import type {Expand} from '../types';

import {offerExpandCommon} from '../offer';
import {editionExpandCommon, programExpandCommon} from '../program';
import {subtenantExpandCommon} from '../subtenant';
import {userExpandCommon} from '../user';

export const courseExpandCommon: Expand = {
  course: [
    ['program_id', {title: 'Program not found'}, programExpandCommon],
    ['edition_id', null, editionExpandCommon],
    ['current_offer_id->currentOffer', null, offerExpandCommon],
    ['client_id', {name: 'Client not found'}, userExpandCommon],
    ['coach_ids->expandedCoaches', {name: 'User not found'}, userExpandCommon],
    ['subtenant_id', null, subtenantExpandCommon],
  ],
};
